module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_5012.c8069b8d.png";